import mqttDispatcher from 'modules/mqtt-dispatcher'
import run from 'modules/run'

export default function runJob (name, params, callback) {
  if (typeof params === 'function') {
    callback = params
    params = {}
  }

  if (!mqttDispatcher.isConnected()) {
    callback(`Unable to run ${name} without MQTT connection`)
    return
  }

  run(name, params, (error, results) => {
    if (error) {
      callback(error)
    } else {
      const { jobId, deviceId } = results

      mqttDispatcher.onJobComplete({
        deviceId,
        jobId
      }, callback)
    }
  })
}



// WEBPACK FOOTER //
// /Users/alextaxiera/source/farmhand-server/client/dashboard/src/js/modules/run-job.js